<template>
    <div class="introduce__conten">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class=" introduce__box">
            <div class="over wrapper__w introduce__text  animate__animated animate__fadeIn">
                <div class="fl ">
                    <div class="base">
                        <div class="title"><span>隐上简介</span></div>
                        <div class="des">
                            <p>隐上装饰前身是杭城首家提倡“工程管理”的源之通装饰工程管理有限公司。公司坚持专注高端装饰发展战略，秉承精益求精的工匠精神，实行专业的“3+1管家式服务”模式，携手众多行业内顶尖设计大师达成战略合作，以“客户满意度”为己任，矢志打造为高端业主提供专属私人定制服务的装饰企业。</p>

                            <p>经过初创期、成长期、成熟期16年的发展，隐上团队凭借专业精湛的施工工艺及高效运营模式赢得广大客户的赞誉与信赖。</p>

                            <p>2015年10月，为升级企业品牌形象，打造高端装饰“百年企业”理念，来自杭州建筑装饰行业的实力派人物胡发录先生创立了浙江隐上装饰设计工程有限公司，更有缘携手圣都装饰掌舵人颜伟阳先生助力隐上，共同推动隐上团队在高端装饰行业的稳步发展。2016年胡发录先生更进一步与杭城装饰工程实力专家高中华先生合力，共同以提供高端别墅装饰服务为己任，推动隐上装饰步入新一层台阶。</p>
                        </div>
                    </div>
                    <div class="base__img--int"><img :src="icon_int02"></div>
                </div>
                <div class="int__right fr">
                    <img :src="icon_int01">
                </div>
            </div>
            <div class="wrapper__w  introduce__culture">
                <div class="bg" :style="{'background': 'url('+icon_int03+')', 'background-repeat': 'no-repeat',
                    'background-size': '100% 100%'}">
                    <div class="title wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s"><span>隐上文化</span></div>
                    <div class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                        品牌起源：<br>
                        隐者，藏也；上者，最也。<br>
                        最高级别的隐，寓意为：抱朴守真，无需彰显而自显的状态。<br>
                        隐上装饰，秉持内敛、厚积的东方文化传统，不断钻研施工工艺，<br>
                        以拳拳匠心，塑就企业立身之本。
                    </div>
                </div>
            </div>
            <div class="wrapper__wpd introduce__text introduce__symbolic">
                <div class="int__right fl  wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                    <img :src="icon_int04">
                </div>
                <div class="fr  wow animate__fadeInUp" data-wow-delay=".3s" data-wow-duration="0.8s">
                    <div class="base">
                        <div class="title"><span>标志寓意</span></div>
                        <div class="des">
                            <p>秉持创新的价值追求与传承东方文化，隐上的标志从中国传统的窗格与大门中取材，运用了中国传统的雕刻花纹元素，古典而艺术。隐者，藏也；上者，最也。隐上，最高级别的隐，寓意为：抱朴守真，无需彰显而自显的状态。</p>
                            <p>隐上标识——“门”或“窗”代表家，隐上将“门”或“窗”的变形融入企业标识中，彰显出“家”在隐上中的重要位置，我们做的不仅仅是装饰，而是要为客户打造出优质舒适的家。</p>
                            <p>橙红色的窗象征着家的环境和氛围，寓意家的温馨与舒适；同时将橙红色融入企业标识，寓意温暖，意味隐上作为一家高端装饰企业，将以暖心贴心的服务，为客户带来尊贵个性的入住体验。</p>
                            <p>隐上LOGO的主文字部分采用灰色的等线体字体，与活泼的橙红色窗花搭配，稳重优雅，诠释出极致简约而低调华丽的特性。</p>
                        </div>
                    </div>
                    <div class="base__img--int  wow animate__fadeInRight" data-wow-delay=".2s" data-wow-duration="0.8s"><img :src="icon_int05"></div>
                </div>
                <div style="clear: both"></div>

            </div>

        </div>
        <div class="footer">
            <Footer></Footer>
        </div>
    </div>
</template>

<script>
    import icon_stra from '@/assets/img/add01.png'
    import icon_int01 from '@/assets/img/int01.png'
    import icon_int02 from '@/assets/img/int02.png'
    import icon_int03 from '@/assets/img/int03.png'
    import icon_int04 from '@/assets/img/int04.png'
    import icon_int05 from '@/assets/img/int05.png'

    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'


    export default {
        name: 'Test',
        data (){
            return {
                icon_stra, icon_int01, icon_int02, icon_int03, icon_int04, icon_int05
            }
        },
        components: {
            NavSecond,Footer
        },
        mounted() {
            this.$wow.init()
        },
    }
</script>
<style  lang="scss" scoped>
    .introduce__conten{
        .introduce__box {
            padding-top: 70px;
            .title {
                font-size: 32px;
                font-weight: bold;
                color: #010101;
                margin: 40px 0;
                span {
                    position: relative;

                    &::after {
                        content: '';
                        display: block;
                        position: absolute;
                        left: 0;
                        bottom: -10px;
                        width: 32px;
                        height: 4px;
                        background: #F55E1B;
                    }
                }

            }
            .introduce__text{
                & > div{
                    width: 50%;
                }
                .base__img--int{
                    margin-top: 50px;
                    position: relative;
                    top: 50px;
                    img{
                        width: 92%;
                        display: block;
                    }
                }
                .base{
                    margin: 0 15%;
                }

                .des{
                    font-size: 16px;
                    font-weight: 400;
                    color: #010101;
                    line-height: 24px;
                    margin-top: 40px;
                    p{
                        margin-top: 20px;
                    }
                }

                .int__right{
                    img{
                        display: block;
                        width: 90%;
                        float: right;
                    }
                }
            }
            .introduce__culture{
                .bg {
                    margin-top: 80px;
                    margin-bottom: 100px;
                    height: 380px;
                    color: #fff;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 24px;
                    padding-left: 120px;

                    .title {
                        color: #fff;
                        padding-top: 90px;
                    }
                }
            }
            .introduce__symbolic{
                background: #F1F1F1;
                padding-top: 80px;
                .int__right{
                    img{
                        float: left;
                        margin-top: 30px;
                    }
                }
                .base__img--int{
                    img{
                        /*width: 82%;*/
                        float: right;
                    }
                }
            }

        }
        .footer{
            padding-top: 150px;
        }
        /*.footer__box{*/
        /*    padding-top: 200px;*/
        /*}*/
    }

</style>
